import AbstractService from '../../vendors/services/abstractService';
import {urlApi} from '../shared/apis/api';

export default class ContribuicaoService extends AbstractService {

  constructor() {
    super(urlApi, 'ManterContribuicao');
  }

  public getMinhaContribuicao(filter: any) {
    const serialized = this.serialize(filter);
    return this.api.get(`${this.rota}/MinhaContribuicao?${serialized}`);
  }

  public getContribuicoesPublicadas(codigoAudienciaPublica: any, codigoContribuinte?: any) {
    if(codigoContribuinte != null && codigoContribuinte != ""){
      return this.api.get(`${this.rota}/ContribuicoesPublicadas?codigoAudienciaPublica=${codigoAudienciaPublica}&codContribuinte=${codigoContribuinte}`);
    }else{
      return this.api.get(`${this.rota}/ContribuicoesPublicadas?codigoAudienciaPublica=${codigoAudienciaPublica}`);
    }
  }

  public getCienciaEvento() {
    return this.api.get(`${this.rota}/CienciaDoEvento`)
  }

  public getPesquisaSatisfacao() {
    return this.api.get(`${this.rota}/PesquisaSatisfacao`)
  }

  public isPrimeiraContribuicao(codContribuinte: any, codContribuicao: any) {
    const obj: any = {codAudienciaPublica: codContribuicao, codcontribuinte: codContribuinte};
    const serialized = this.serialize(obj);
    return this.api.get(`${this.rota}/PrimeiraContribuicao?${serialized}`)
  }

  public getAnexoContribuicao(codContribuinte: any, codContribuicao: any) {
    const obj: any = {codContribuicao: codContribuicao};
    const serialized = this.serialize(obj);
    return this.api.get(`${this.rota}/AnexoContribuicao?${serialized}`)
  }

  public finalizar(evento: any) {
    return this.api.post(`${this.rota}/Finalizar`, evento);
  }

  public ativar(payload: { codAudienciaPublica: number; codContribuinte: number }) {
    return this.api.put('/contribuicoes/ativar', payload);
  }

  public atualizar(payload: {
    codContribuicao: number;
    dsContribuicao: string;
    dsJustificativa: string;
    dsContribuicaoSigilosa?: string;
  }) {
    return this.api.put('/contribuicoes', payload, {
      skipAuthRedirect: true,
    } as any);
  }

  public validaCaptcha(response: any) {
    const obj: any = {response: response};
    const serialized = this.serialize(obj);
    return this.api.get(`${this.rota}/ValidaCaptcha?${serialized}`);
  }

    public getContribuicao(id: any, codContribuinte?: any) {
      if(codContribuinte != null){
        return this.api.get(`${this.rota}/${id}?codContribuinte=${codContribuinte}`)
      }else{
        return this.api.get(`${this.rota}/${id}`)
      }
  }

}
